var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kpkda",
    d: "M215 875v18c0 2.2-1.8 4-4 4H210.94c-.35 0-.7-.06-1.02-.15L190.45 894a5.48 5.48 0 0 1-5.45-5.5c0-1.82.88-3.43 2.23-4.43l12.6-12.6A8.02 8.02 0 0 1 207 867c4.4 0 8 3.6 8 8zm-14.29-3.07A6.94 6.94 0 0 0 200 875c0 3.85 3.15 7 7 7s7-3.15 7-7-3.15-7-7-7a7.02 7.02 0 0 0-6.29 3.93zM190.5 893c2.5 0 4.5-2 4.5-4.5a4.48 4.48 0 0 0-7.26-3.56 4.48 4.48 0 0 0-1.74 3.56c0 2.5 2 4.5 4.5 4.5zm23.5 0a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3zm0-14.14a8.02 8.02 0 0 1-7 4.14 8.02 8.02 0 0 1-7.87-9.43l-9.5 9.5a5.48 5.48 0 0 1 6.37 5.43c0 2.15-1.21 4-3 4.9l14.96 2.2a4.01 4.01 0 0 1 6.04-5.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdb",
    d: "M210.5 892c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdc",
    d: "M207.5 872c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdd",
    d: "M207.5 878c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkde",
    d: "M190.5 891c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zm0-1c.85 0 1.5-.65 1.5-1.5s-.65-1.5-1.5-1.5-1.5.65-1.5 1.5.65 1.5 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdf",
    d: "M210.5 876c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdg",
    d: "M203.5 876c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdh",
    d: "M204.5 873c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdi",
    d: "M209.5 877c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdj",
    d: "M209.5 873c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdk",
    d: "M204.5 877c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdl",
    d: "M201 875c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6zm1 0c0 2.75 2.25 5 5 5s5-2.25 5-5-2.25-5-5-5-5 2.25-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpkdm",
    d: "M205 875c0-1.1.9-2 2-2a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2zm1 0a1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkda"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkde"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdf"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdg"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdh"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdi"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdj"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdk"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdl"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185 -867)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#kpkdm"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.0b71df61fa03bbcf0b08055b38695d05.svg";
export { ForwardRef as ReactComponent };